/** A chat's page: `/andi` for a new chat, `/andi/chats/:chatId` for an existing one. */
export const andiChatPath = (projectId: string | undefined, chatId?: string | null) => (
  chatId
    ? `/projects/${projectId}/andi/chats/${chatId}`
    : `/projects/${projectId}/andi`
);

/** The dashboard's placeholder for "no project chosen yet" in an address (see ProjectProtectedPage), never a
 *  real project. */
export const NO_PROJECT = '_';

export const PRIVACY_POLICY_URL = 'https://www.withampersand.com/privacy';

export const UNTITLED_CHAT = 'Untitled chat';

/** Long enough that the page and the chat's history load share one request. */
export const CHAT_STALE_TIME_MS = 5_000;

/** A burst of activity during a reply is one refresh of the chat. */
export const CHAT_REFRESH_DEBOUNCE_MS = 400;

/** How long a reply we can't see the end of is followed before it counts as interrupted. */
export const FOLLOW_REPLY_FOR_MS = 15 * 60_000;

export const BUILD_STATUS_POLL_MS = 3_000;

/** How often a submitted chat asks whether Ampersand's team wants its credentials (the credentials card). */
export const CREDENTIAL_CARD_POLL_MS = 30_000;

/** Whether the chat shows the build's progress (reviewing docs, building, a snag). Off for now: once
 *  a request is filed the chat shows only that it was submitted and, when the build needs them, the
 *  credentials card; the team tells the builder about the rest themselves. */
export const SHOW_BUILD_PROGRESS = false;

/** Rapid rating toggles send only the final rating. */
export const RATING_DEBOUNCE_MS = 400;

/** How long "Copied" shows after a copy. */
export const COPIED_MS = 1_500;

/** How often "2 minutes ago" and the like are brought up to date. */
export const TIME_AGO_REFRESH_MS = 30_000;

/** A credential link lasts three days. */
export const CREDENTIAL_LINK_TTL_MINUTES = 3 * 24 * 60;

/** A preview of the link's page lasts an hour. */
export const CREDENTIAL_LINK_PREVIEW_TTL_MINUTES = 60;
